import { useNavigate } from 'react-router-dom';

import { ContentEntityTypeForm } from '../components/ContentEntityTypeForm';

export const CreateContentEntityTypePage = () => {
  const navigate = useNavigate();

  return (
    <div className="p-10">
      <div>
        <ContentEntityTypeForm
          type="Create"
          onSubmit={async (contentEntityTypeId) => {
            navigate(`/content-entity-types`);
          }}
          onCancel={() => {
            navigate(`/content-entity-types`);
          }}
        />
      </div>
    </div>
  );
};
